import React from "react";
import {
  Card,
  Table,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import {$} from "moneysafe"
import "../../assets/css/table.css"
import { useState, useEffect } from "react";


function ProductsTable({
  products,
  setProducts
}) {
  const [checkAll, setCheckAll] = useState(false);

  if (!products) {
    return null;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MAD',
  });

  const checkBoxHandler = (status, id) => {
    let updatedProducts = [...products];
    products.forEach((p) => {
      if (p.id == id)
        p.checked = status;
    })
    setProducts(updatedProducts);
  }
  const checkAllHandler = (e) => {
    let updatedProducts = [...products];
    products.forEach(p => p.checked = e.target.checked);
    setProducts(updatedProducts);
    setCheckAll(e.target.checked);
  }
  
  const format = (price) => formatter.format(price)
  
  const handleInputChange = (e, id, key) => {
    let updatedProducts = [...products];
    products.forEach((p) => {
      if (p.id == id)
        p[key] = e.target.value
    })
    setProducts(updatedProducts);
  } 
  const quantity = (product, key) => {
    if (product.checked)
      return <input type="number" value={product[key]} onChange={(e) => handleInputChange(e, product.id, key)}/>
    return product[key]
  }

  return (
    <>
        <Row>
          <Col md="12">
            <Card className="card-plain table-plain-bg">
              <Card.Body className="table-full-width table-responsive px-0">
                <Table id="invoice">
                  <thead>
                    <tr>
                      <th className="border-0">
                        <input type="checkbox" checked={checkAll} onChange={checkAllHandler}></input>
                      </th>
                      <th className="border-0">Id</th>
                      <th className="border-0">Name</th>
                      <th className="border-0">Price</th>
                      <th className="border-0">Box Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => {
                      if (product.hide)
                        return ;
                      return (
                        <tr key={index}>
                          <td>
                            <input type="checkbox" checked={product.checked} onChange={(e) => checkBoxHandler(e.target.checked, product.id)}></input>
                          </td>
                          <td>{product.id}</td>
                          <td>{product.name}</td>
                          <td>{format(product.price)}</td>
                          <td>{quantity(product, 'boxQuantity')}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
    </>
  );
}

export default ProductsTable;
